import mergeWith from 'lodash.mergewith';

export {
  // eslint-disable-next-line
  nonEmptyProps,
  propToNum,
  hasProps,
  deepMerge,
};

/**
 * nonEmptyProps
 *
 * accepts an object and returns a brand new object
 * containing the fields that their values are truthy
 * i.e. items w/ falsy values are ignored in the new object
 *
 * @param obj
 * @returns {{}}
 */
function nonEmptyProps(obj = {}) {
  return Object.keys(obj)
    .filter(field => Boolean(obj[field]))
    .reduce(
      (result, field) => Object.assign({}, result, { [field]: obj[field] }),
      {},
    );
}

/**
 * propToNum
 *
 * returns a function which accepts an object as its argument
 * and returns a brand new object with 'prop' item casted to Number
 *
 * @param prop
 * @returns {function(*=): *}
 */
function propToNum(prop) {
  return obj =>
    Object.assign({}, obj, {
      [prop]: Number(obj[prop]),
    });
}

function hasProps(obj) {
  return Object.keys(obj).length;
}

function mergeWithCustomizer(firstValue, secondValue) {
  if (Array.isArray(firstValue) && Array.isArray(secondValue))
    return firstValue.concat(secondValue);
}
/**
 * deepMerge
 *
 * accepts two object and returns a brand new object
 * containing the fields that their values are merged
 * of two object
 *
 * @param {obj,obj}
 * @returns {obj}
 */
function deepMerge(first, second) {
  return mergeWith({}, first, second, mergeWithCustomizer);
}
